import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";
//  import {v4} from "uuid";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

///otherwise falls back to the 'uuid' package.
/**
 * Generate a RFC4122 v4 UUID.
 * Uses crypto.randomUUID if available,
 *
 */
export function generateUuid(): string {
  //   if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
  return crypto.randomUUID();
  //   }
  // Fallback for older environments: use the 'uuid' package
  // return v4();
}
